export enum RefetchInterval {
  VeryFast = 2_000,
  // 6 seconds
  Fast = 6_000,
  // 10 seconds
  Normal = 10_000,
  // 1 minutes
  Slow = 60_000,
}

export const TOP_NAV_HEIGHT = 56;
export const MAX_WIDTH = 1170;

export const TOAST_DURATION_MS = 6000;

// seems H2 just 6 by default https://psta2-h2.crorc.co/swap?outputCurrency=0x52b8F3CF7A73e650CB824ca8629ec8899bbf7B89
export const DEFAULT_DECIMAL_PLACES = 12;
